import { get } from './sp-api.service';
import { RecentServiceModel } from '../models/recent-service.model';
import { JsonObject } from '../helpers';

type RecentServicesListResponse = {
  services: JsonObject[];
};

export const getRecentServicesByUser = async (): Promise<RecentServiceModel[]> => {
  const response = (await get('/analytics/my-recent-services')) as RecentServicesListResponse;

  if (!Array.isArray(response?.services)) {
    return [];
  }

  return response.services.map((row) => new RecentServiceModel(row));
};
